import styled from "styled-components";

export const RowCount = styled.div`
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  color: black;
  margin-top: 15px;
`;

export const Content = styled.div`
  font-size: 18px;
  font-weight: 500;
  color: black;
  margin-bottom: 15px;
`;
